// If all items in the selection have the same value for the given attribute, return that value.  Otherwise return null.
export function getSharedAttribute<I, V>(list: I[], attribute: keyof I | ((i: I) => V)): V | null {
  if (!list?.length) return null;
  const getValue: (i: I) => V =
    typeof attribute === "function"
      ? (attribute as (i: I) => V)
      : (i: I) => i[attribute as keyof I] as unknown as V;
  const firstValue = getValue(list[0]);
  return list.every(item => getValue(item) === firstValue) ? firstValue : null;
}
